import React from "react";
import {
  Input,
  Button,
  Select,
  SelectItem,
  Tabs, 
  Tab,
} from "@heroui/react";
import GlossaryTab from "../components/settings/GlossaryTab";
import PromptsTab from "../components/settings/PromptsTab";

export const ListboxWrapper = ({ children }) => (
  <div className="w-full border-small px-1 py-2 rounded-small border-default-200 dark:border-default-100">
    {children}
  </div>
);



const Settings = () => {
  return (
    <div className="h-[82vh]  overflow-auto bg-transparent rounded-2xl px-4">
      <Tabs
        size="lg"
        variant="underlined"
        aria-label="Options"
        classNames={{
          tabList: "gap-2",
          cursor: "bg-primary", // underline color
          tabContent: "group-data-[selected=true]:text-primary",
        }}
      >
        <Tab key="glossary" title="Glossary">
          <GlossaryTab />
        </Tab>
        <Tab key="prompts" title="Prompts">
          <PromptsTab/>
        </Tab>
    </Tabs>


      
    </div>
  );
};

export default Settings;
